export default __webpack_public_path__ + "static/media/error-bg-dark.fa9d2a46.svg";